export enum ConciliationStatusEnum {
  'Em análise' = 1,
  'Aguardando aprovação' = 2,
  'Autorizado' = 3,
  'Não autorizado' = 4,
  'Efetivado' = 5,
}
